import { render, staticRenderFns } from "./EcplFooter.vue?vue&type=template&id=808349cc&scoped=true"
import script from "./EcplFooter.vue?vue&type=script&lang=js"
export * from "./EcplFooter.vue?vue&type=script&lang=js"
import style0 from "./EcplFooter.vue?vue&type=style&index=0&id=808349cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808349cc",
  null
  
)

export default component.exports